import loggedIn from './logged-in';

document.body.setAttribute('data-js-user-logged-in', (loggedIn ? 'true' : 'false'));
